<script>
import { Payment } from '@/enums/Payment'
import BaseDataForm from '@/components/profile/billingData/BaseDataForm.vue'

export default {
  components: {
    BaseDataForm
  },
  props: {
    price: { type: Object },
    payment: { type: Number },
    loadingPrice: { type: Boolean }
  },
  data: () => ({
    salutations: [],
    salutation: '',
    firstName: '',
    lastName: '',
    address: '',
    addressAddition: '',
    zipCode: '',
    city: '',
    loading: true,
    showBaseDataForm: false,
    error: false,
    paymentEnum: Payment
  }),
  computed: {
    fullName: function () {
      return this.firstName + ' ' + this.lastName
    },
    fullStreet: function () {
      return this.address + ' ' + this.addressAddition
    },
    fullDestination: function () {
      return this.zipCode + ' ' + this.city
    },
    // important for "CheckoutNextStep.vue"
    emptyBaseData() {
      let baseDataStatus = this.isEmptyBaseData()
      this.$emit('emptyBaseData', baseDataStatus)
      return baseDataStatus
    },
    totalTaxValue() {
      return this.price.totalTaxValue
    },
    paypalPayment() {
      return this.payment === Payment.PayPal && this.price.fee
    }
  },
  watch: {
    // important for "PaymentOpen.vue"
    error(errorState) {
      this.$emit('profilError', errorState)
    }
  },
  created: function () {
    this.salutations = this.getSalutations()
    this.getUserProfile()
  },
  methods: {
    // emit from baseDataForm
    // trigger when user saves the baseData
    submittedBaseDataForm: function (submitStatus) {
      if (submitStatus) {
        setTimeout(() => this.getUserProfile(), 3000)
      }
    },
    getUserProfile: function () {
      this.error = false
      this.$userService
        .getUserProfile()
        .then(response => {
          this.salutation = this.salutations[response.salutation]
          this.firstName = this.convertNull(response.firstName)
          this.lastName = this.convertNull(response.lastName)
          this.address = this.convertNull(response.address)
          this.addressAddition = this.convertNull(response.addressAddition)
          this.zipCode = this.convertNull(response.zipCode)
          this.city = this.convertNull(response.city)
          if (this.isEmptyBaseData()) this.showBaseDataForm = true
          else this.showBaseDataForm = false
        })
        .catch(e => {
          // show error
          if (e.response.status !== undefined && e.response.status !== 404)
            this.error = true
          else {
            // user not found in apl
            // the basedata is empty
            // show BaseDataForm
            this.showBaseDataForm = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // converts null-value to empty string
    convertNull(value) {
      if (value === null || value === undefined) return ''
      return value
    },
    isEmptyBaseData() {
      if (
        this.firstName === '' ||
        this.lastName === '' ||
        this.address === '' ||
        this.zipCode === '' ||
        this.city === ''
      ) {
        return true
      }
      return false
    },
    getSalutations() {
      return [
        this.$t('form.label.mr'),
        this.$t('form.label.mrs'),
        this.$t('form.label.company')
      ]
    }
  }
}
</script>
<template>
  <div class="text--secondary grey lighten-4 ml-3 mr-3 pa-4">
    <v-skeleton-loader
      :loading="loadingPrice"
      transition="slide-x-transition"
      height="94"
      type="list-item-three-line" >
      <v-card elevation="0" class="text--secondary transparent">
        <v-row>
          <v-col :cols="paypalPayment ? 9 : 6" sm="6" class="pb-0 pt-0">
            <p id="netPrice">
              {{ $t('component.checkout.checkoutDetails.netto.price') }}
              <i v-if="paypalPayment">
                <currency :value="price.fee.value"
                ><template #default="slotProps">
                  {{ $t('component.checkout.checkoutDetails.netto.price.paypal', {
                      '{FEE_VALUE}': slotProps.currencyValue }) }}
                </template>
                </currency>
              </i>
            </p>
          </v-col>
          <v-col cols="2" class="pb-0 pt-0 text-no-wrap">
            <p id="totalNet">
              <currency>{{ price.totalNetPrice }}</currency>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="paypalPayment ? 9 : 6"
            sm="6"
            class="pb-0 pt-0 text-no-wrap" >
            <p id="mwst">{{ $t('component.checkout.checkoutDetails.mwst') }}</p>
          </v-col>
          <v-col cols="1" class="pb-0 pt-0 text-no-wrap">
            <p id="totalTax"><currency>{{ totalTaxValue }}</currency></p>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            :cols="paypalPayment ? 9 : 6"
            sm="6"
            class="pb-0 pt-0 text-no-wrap" >
            <p id="checkoutPrice">{{ $t('component.checkout.checkoutDetails.price') }}</p>
          </v-col>
          <v-col cols="1" sm="1" class="pb-0 pt-0 text-no-wrap">
            <p>
              <currency>{{ price.totalGrossPrice }}</currency>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-skeleton-loader>
    <v-skeleton-loader
      :loading="loading"
      transition="slide-x-transition"
      height="94"
      type="list-item-three-line"
      class="pt-2">
      <v-card elevation="0" class="text--secondary transparent">
        <v-row
          class="text--secondary"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pt-4'">
          <v-col cols="12" sm="6" md="12" lg="6" class="pb-0 text-no-wrap">
            <p> {{ $t('component.checkout.checkoutDetails.bill.address') }}</p></v-col>
          <v-col
          cols="12"
          sm="6"
          md="12"
          lg="6"
          class="pb-0 text-no-wrap"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'pl-0'" >
          <v-btn
            v-if="!emptyBaseData"
            id="editBtn"
            color="primary"
            outlined
            @click="showBaseDataForm = !showBaseDataForm"
          ><v-icon color="primary" left>mdi-pencil-outline</v-icon>
            {{ $t('component.checkout.checkoutDetails.edit') }}
            <v-icon v-if="!showBaseDataForm" color="primary" right>
              mdi-menu-down</v-icon>
            <v-icon v-else color="primary" right>mdi-menu-up</v-icon></v-btn>
        </v-col></v-row>
        <v-row class="text--secondary">
          <v-expand-transition>
            <v-col
              v-if="!showBaseDataForm"
              cols="6"
              sm="6"
              md="6"
              class="pb-0 primary--text"
              transition="scroll-y-transition">
              <p> {{ salutation }}<br />{{ fullName }}<br />
                {{ fullStreet}}<br />{{ fullDestination }}</p>
            </v-col>
          </v-expand-transition>
          <v-expand-transition>
            <v-col v-if="showBaseDataForm" cols="12" class="pb-0">
              <div>
                <v-alert v-if="emptyBaseData" type="error">
                  {{ $t('component.checkout.checkoutDetails.please.edit') }}
                </v-alert>
                <BaseDataForm
                  v-if="showBaseDataForm || emptyBaseData"
                  :hide-info-text="true"
                  :shrink="true"
                  @submitted="submittedBaseDataForm"/>
              </div>
            </v-col>
          </v-expand-transition>
        </v-row>
      </v-card>
    </v-skeleton-loader>
  </div>
</template>
<style lang="scss" scoped>
p {
  color: var(--v-primary-base);
  margin-bottom: 0px;
}
.expand-transition-enter-active,
.expand-transition-enter-to,
.expand-transition-leave-active,
.expand-transition-leave-to {
  transition: all 1s !important;
}
</style>
